import { VueI18n } from 'vue-i18n';
import store from '/@/store/store';
import translations from '/@/translations';
import { LanguageModule } from '/@/store/enums';
import { ConfigModule } from '/@/store/enums';
import { Router } from 'vue-router';

class I18nHelper {
	$i18n?: VueI18n;
	$router?: Router;

	setI18n($i18n: VueI18n) {
		this.$i18n = $i18n;
	}

	setRouter($router: Router) {
		this.$router = $router;
	}

	setInitialLanguage() {
		const defaultLanguage = 'hu';
		const languages = ['hu', 'en'];
		const storedLanguage = undefined; // localStorage.getItem('language');
		// const navigatorLanguage = navigator.language.substring(0, 2);

		let initialLanguage = defaultLanguage;

		if (storedLanguage && languages.indexOf(storedLanguage) !== -1) {
			initialLanguage = storedLanguage;
		}/* else if (navigatorLanguage && languages.indexOf(navigatorLanguage) !== -1) {
			initialLanguage = navigatorLanguage;
		}*/

		console.log('[i18n]', 'initialLanguage', initialLanguage);

		this.setLanguage(initialLanguage, true);

		return initialLanguage;
	}

	getFallbackLanguage() {
		return 'en';
	}

	getTranslations(): {[key: string]: any} {
		return translations;
	}

	updateTranslations() {
		const _translations = this.getTranslations();

		for (const locale in _translations) {
			i18nHelper.$i18n?.setLocaleMessage(locale, _translations[locale]);
		}
	}

	getCurrentLanguage() {
		return this.$i18n?.locale as string;
	}

	setLanguageByPath() {
		this.$router?.isReady().then(() => {
			console.log('[i18n]', 'setLanguageByPath()', 'ready');

			const path = this.getCurrentRoutePath();

			if (path === '/') {
				return;
			}

			const language = this.getLanguageByPath(
				this.getTranslations(),
				path,
			);

			if (language) {
				console.log('[i18n]', 'setLanguageByPath()', language);

				if (language !== this.getCurrentLanguage()) {
					this.setLanguage(language, true);
				} else {
					this.setHtmlLanguage(language);
				}
			}
		});
	}

	setLanguage(language: string, initial: boolean = false) {
		console.log('[i18n]', 'setLanguage()', language, initial);

		const oldLanguage = this.getCurrentLanguage();

		if (this.$i18n) {
			this.$i18n.locale = language;
		}

		this.saveLanguage(language);
		this.setHtmlLanguage(language);

		if (!initial) {
			this.storeDispatch(language);

			setTimeout(() => {
				this.storeClear();
				this.changePathIfPossible(oldLanguage, language);
			});
		}
	}

	saveLanguage(language: string) {
		console.log('[i18n]', 'saveLanguage()', language);

		localStorage.setItem('language', language);
	}

	setHtmlLanguage(language: string) {
		console.log('[i18n]', 'setHtmlLanguage()', language);

		document.documentElement.setAttribute('lang', language);
	}

	storeDispatch(language: string) {
		console.log('[i18n]', 'storeDispatch()');

		store.dispatch(LanguageModule.CHANGE_LANGUAGE, language);
	}

	storeClear() {
		console.log('[i18n]', 'storeClear()');

		store.dispatch(ConfigModule.CLEAR_STORE);
	}

	changePathIfPossible(oldLanguage: string, newLanguage: string) {
		console.log('[i18n]', 'changePathIfPossible()', oldLanguage, '->', newLanguage);

		const path = this.getCurrentRoutePath();
		const translations = this.getTranslations();

		const routesOld = translations[oldLanguage].routes;
		const routesNew = translations[newLanguage].routes;



		const routeName = this.getKeyByValue(routesOld, path);

		if (routeName && routesNew[routeName] !== path) {
			console.log('[i18n]', routeName, 'redirecting', routesOld[routeName], '->', routesNew[routeName]);

			this.$router?.replace({
				path: routesNew[routeName],
				force: true,
			});
		}
	}

	getCurrentRoutePath() {
		return this.$router?.currentRoute.value.path as string;
	}

	getCurrentRouteQuery() {
		return this.$router?.currentRoute.value.query;
	}

	getRouter() {
		return this.$router;
	}

	getLanguageByPath(translations: {[key: string]: any }, path: string) {
		for (const language in translations) {
			for (const routeName in translations[language].routes) {
				const _path = translations[language].routes[routeName];

				if (_path === path || path.startsWith(_path + '/')) {
					// check if present in other languages
					let foundInAnotherLanguage = false;

					for (const _language in translations) {
						if (
							_language !== language &&
							translations[_language].routes[routeName] === _path
						) {
							foundInAnotherLanguage = true;
							break;
						}
					}

					if (!foundInAnotherLanguage) {
						return language;
					}
				}
			}
		}
	}

	getKeyByValue(object: any, value: any) {
		return Object.keys(object).find(key => object[key] === value);
	}
}

const i18nHelper = new I18nHelper();

if ((import.meta as any).hot) {
	(import.meta as any).hot.accept(
		(newModule: any) => {
			const newI18nHelper: I18nHelper = newModule.default;
			newI18nHelper.setI18n(i18nHelper.$i18n as VueI18n);
			newI18nHelper.setRouter(i18nHelper.$router as Router);
			newI18nHelper.updateTranslations();
		},
	);
}

export default i18nHelper;
